import { RemoteEvaluateContext } from "../../model/RemoteEvaluateContext"
import { WorkspaceEvaluationContext } from "../../WorkspaceEvaluationContext"
import { WorkspaceEvaluateRequestDto } from "../../model/dto"
import { WorkspaceEvaluatePolicy } from "../../model/WorkspaceEvaluatePolicy"
import WorkspaceEvaluateRequest from "../WorkspaceEvaluateRequest"

/**
 * A whole-workspace evaluation request. Without a cached record it forces a FULL fetch
 * (`FORCE_FULL`); with one it sends an `AUTO` request carrying the cached base so the server can
 * answer FULL, DELTA, or not-modified (HTTP 204).
 */
export class FullWorkspaceEvaluateRequest implements WorkspaceEvaluateRequest {
  constructor(
    readonly context: RemoteEvaluateContext,
    readonly policy: WorkspaceEvaluatePolicy,
    readonly base: WorkspaceEvaluationContext | null
  ) {}

  static of(context: RemoteEvaluateContext, base: WorkspaceEvaluationContext | null): FullWorkspaceEvaluateRequest {
    const policy = base ? "AUTO" : "FORCE_FULL"
    return new FullWorkspaceEvaluateRequest(context, policy, base)
  }

  toForceFull(): FullWorkspaceEvaluateRequest {
    if (this.policy === "FORCE_FULL") {
      return this
    }
    return new FullWorkspaceEvaluateRequest(this.context, "FORCE_FULL", null)
  }

  toDto(): WorkspaceEvaluateRequestDto {
    return {
      policy: this.policy,
      context: this.context.toDto(),
      base: this.base?.toBaseEvaluationDto() ?? null
    }
  }
}
